module.exports = __webpack_public_path__ + "img/swiperimg1.07be7ae5.jpg";